//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DefaultLayout from '~/layouts/default.vue';
import PrimaryHeader from '~/components/headers/PrimaryHeader';
import JobInviteDialog from '../components/jobs/JobInviteDialog.vue';
import candidateActions from '~/mixins/candidateActions';

export default {
    name: 'candidate',

    mixins: [candidateActions],

    components: {
        JobInviteDialog,
        DefaultLayout,
        PrimaryHeader,
    },

    data() {
        return {
            loading: true,
            error: false,
            showInterviewDialog: false,
            showJobInviteDialog: false,
            showRejectionDialog: false,
            showMakeOffer: false,
            showAcceptBursaryApplicationModal: false,
            hasInterviews: null,
            tabs: [
                {
                    name: 'Profile',
                    href: `/candidates/${this.$route.params.id}`,
                },
                {
                    name: 'Jobs',
                    href: `/candidates/${this.$route.params.id}/jobs`,
                },
                {
                    name: 'Bursaries',
                    href: `/candidates/${this.$route.params.id}/bursaries`,
                },
            ],
        };
    },

    computed: {
        candidate() {
            return this.$store.getters['applications/getApplicant'];
        },

        referringApplication() {
            return this.$route.query.referring_application;
        },

        hasReferringApplication() {
            return Boolean(this.referringApplication);
        },

        jobApplication() {
            return this.$store.getters['applications/getJobApplication'];
        },

        job() {
            return this.$store.getters['jobs/single/getSingleJob'];
        },

        jobApplicationIsForBursary() {
            return this.job?.job_type === 'Bursary';
        },

        candidateIsAProspect() {
            return this.candidate.prospect_uuid !== null;
        },

        primaryUniversity() {
            return this.candidate.universities.find((university) => university.account.is_primary);
        },
    },

    async created() {
        this.appendQueryParamsToTabsLinks();

        if (!this.hasReferringApplication) {
            await this.getFullCandidateProfile();
            this.loading = false;
            return;
        }

        this.getJobApplication().then(async () => {
            await Promise.all([
                this.getFullCandidateProfile(),
                this.getJobApplicationAnswers(),
                this.getCandidateInterviews(),
                this.getApplicationOffers(),
            ])
                .then(() => {
                    this.loading = false;
                })
                .catch((error) => {
                    this.error = true;
                    this.loading = false;
                });
        });
    },

    methods: {
        appendQueryParamsToTabsLinks() {
            if (!this.hasReferringApplication) {
                return;
            }

            this.tabs.map((tab) => {
                tab.href = `${tab.href}?referring_application=${this.referringApplication}`;
            });
        },

        getFullCandidateProfile() {
            return this.$store.dispatch('applications/getFullCandidateProfile', {
                applicant_uuid: this.$route.params.id,
                job_uuid: this.job?.uuid,
            });
        },

        async getJobApplication() {
            if (!this.hasReferringApplication) {
                return;
            }

            return await this.$store.dispatch('applications/getJobApplication', this.referringApplication);
        },

        getJobApplicationAnswers() {
            if (!this.hasReferringApplication) {
                return;
            }

            return this.$store.dispatch('applications/getApplicationAnswers', this.referringApplication);
        },

        closeInterviewDialog(newInterview) {
            this.showInterviewDialog = false;
            if (newInterview) {
                this.getCandidateInterviews().then((res) => {
                    this.hasInterviews = res?.data || [];
                });
            }
        },

        closeMakeOffer(newOffer) {
            this.showMakeOffer = false;
            if (newOffer) this.getApplicationOffers();
        },

        closeAcceptBursaryModal() {
            this.showAcceptBursaryApplicationModal = false;
            this.getApplicationOffers();
        },

        confirmRejection() {
            this.showRejectionDialog = true;
        },

        getCandidateInterviews() {
            if (!this.hasReferringApplication) {
                return;
            }

            return this.$store
                .dispatch('applications/getJobInterviews', {
                    uuid: this.job.uuid,
                    params: {
                        candidate_uuid: this.$route.params.id,
                        from_date: null,
                    },
                })
                .then((res) => {
                    this.hasInterviews = res?.data || [];
                });
        },

        async initiateConversation() {
            await this.$store
                .dispatch('conversations/createConversation', {
                    job_uuid: this.job.uuid,
                    candidate_uuid: this.$route.params.id,
                })
                .then((res) => {
                    const messageGroupPath = this.localePath({
                        name: 'messages-name',
                        params: {
                            name: 'all',
                        },
                    });

                    this.$router.push(`${messageGroupPath}/${res.uuid}`);
                });
        },

        getApplicationOffers() {
            if (!this.hasReferringApplication) {
                return;
            }

            return this.$store.dispatch('jobOffers/getJobApplicationOffers', this.referringApplication);
        },

        toggleFavouriteStatus() {
            this.$store.dispatch('applications/toggleApplicationFavouriteStatus', this.referringApplication);
        },

        toggleWeakMatch() {
            this.$store.dispatch('applications/updateApplication', {
                applicationUuid: this.jobApplication.uuid,
                strength: this.jobApplication.strength === 'weak' ? null : 'weak',
            });
        },

        toggleProspectStatus() {
            if (this.candidateIsAProspect) {
                this.$store.dispatch('prospects/deleteProspect', this.candidate.prospect_uuid);
                return;
            }

            this.$store.dispatch('prospects/createProspect', {
                candidate_uuid: this.candidate.uuid,
                profile_picture: this.candidate.profile_picture,
                initials: this.candidate.initials,
                name: this.candidate.name,
                surname: this.candidate.surname,
                candidate_is_manually_verified: this.candidate.is_manually_verified,
                university_code: this.primaryUniversity?.code || null,
            });
        },
    },
};
